import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialCourier() {
  return <IndustryDetailPage industry="courier" />;
}

export default TestimonialCourier;
